import { API_ENDPOINTS } from '../config/apiConfig';
import apiClient from './apiClient';
import { RtuReachabilityQuery, RtuReachabilityResponse } from '../types/RtuReachability';

const stripEmpty = (query: Record<string, string | undefined>) =>
  Object.fromEntries(
    Object.entries(query).filter(([, value]) => value !== undefined && value !== null && value !== '')
  );

export const rtuReachabilityService = {
  async fetch(query: RtuReachabilityQuery): Promise<RtuReachabilityResponse> {
    const response = await apiClient.get<RtuReachabilityResponse>(API_ENDPOINTS.RTU.REACHABILITY, {
      params: stripEmpty({
        range: query.range,
        rtuId: query.rtuId !== undefined ? String(query.rtuId) : undefined,
      }),
    });

    return response.data;
  },
};

export default rtuReachabilityService;
